const SectionTitle = props => {
  return (
    <h2 className={`fw-bold ${props.className}`}>{props.children}</h2>
  );
}

export default SectionTitle;
